export default {
  username: 'Username',
  imageAlt: {},
  status: {
    error: {
      somethingWentWrong: 'Something went wrong',
      sessionError: 'Unable to verify the session, please try again later...',
      failedToLogin: 'Failed to login. Please try again later',
      underMaintenance: 'Under maintenance. Please try again later',
      failWriteToLocalStorage:
        'Unable to save data. Please check your Privacy Settings or available disk space and try again',
      sessionExpired: 'Session expired. Please login again'
    }
  },
  actions: {
    back: 'Back',
    cancel: 'Cancel',
    moveOn: 'Move on',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    next: 'Next',
    save: 'Save {{ addOn }}',
    update: 'Update {{ addOn }}',
    select: 'Select',
    confirm: 'Confirm',
    revoke: 'Revoke',
    close: 'Close'
  },
  or: 'or'
}
